import(/* webpackMode: "eager" */ "/opt/apps/wisprs/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/apps/wisprs/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/apps/wisprs/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/opt/apps/wisprs/src/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/opt/apps/wisprs/src/components/navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductMockupVideo"] */ "/opt/apps/wisprs/src/components/product-mockup-video.tsx");
